(ns common.schema.entities.screening-profile.options)

(def screening-statuses
  [{:key      :screening-status/active
    :label    "Active"
    :i18n/key "screening.status.active"}
   {:key      :screening-status/inactive
    :i18n/key "screening.status.inactive"
    :label    "Inactive"}])

(def sanction-status-options
  [{:key   :sanction-status/green
    :label "Green"}
   {:key   :sanction-status/yellow
    :label "Yellow"}
   {:key   :sanction-status/red
    :label "Red"}])

(def screening-profile-types
  [{:key :screening-profile-type/person :label "Person"}
   {:key :screening-profile-type/company :label "Company"}])

(def screening-service-options
  [{:key   :screening-service/risk-screen
    :label "RiskScreen"}])
